import CrownForm, { Response } from "./CrownForm";

const form = document.querySelector<HTMLFormElement>("#utility-app-form");

if (form) {
  form.addEventListener("keydown", (e) => {
    if (!e.target) return;

    if (
      e.code === "Enter" &&
      (e.target as HTMLInputElement).nodeName !== "TEXTAREA"
    ) {
      e.preventDefault();

      return;
    }
  });

  new CrownForm({
    el: form,

    url: "/wp-content/themes/crownenergy/ajax/UtilityForm.php",

    button: {
      defaultText: "Submit Application",
      submittingText: "Processing...",
    },

    success() {
      window.location.href = "/thank-you-utility-form/";
    },

    error(response: Response) {
      const { code } = response.error;

      const fileInput = document.querySelectorAll<HTMLInputElement>("input[type=file]")[0];

      if (!fileInput) return;

      if (code === "FILE_LIMIT_EXCEEDED") {
        CrownForm.addError(
          "You can only upload a maximum of 5 images",
          fileInput,
        );
      } else if (code === "FILE_TOO_LARGE") {
        CrownForm.addError(
          "One or more of the files you uploaded are too large. Please make sure all files are less than 5MB each.",
          fileInput,
        );
      } else if (code === "INVALID_FILE_TYPE") {
        CrownForm.addError(
          "One or more of the files you uploaded are not supported. Please make sure you are uploading images only.",
          fileInput,
        );
      } else if (code === "ERROR_MOVING_FILE") {
        CrownForm.addError(
          "An error occurred while uploading the file(s). Please try again.",
          fileInput,
        );
      } else {
        this.addError("An error has occurred with the request. Please try again or contact us.");
      }
    },
  });

  const copyEnquirerDetails = document.querySelector(
    "#site-details-copy-enquirer"
  );

  if (copyEnquirerDetails) {
    copyEnquirerDetails.addEventListener("input", function () {
      if (!this.checked) return;

      const elements = [
        [
          "utility-application-enquirer-details[fullname]",
          "utility-application-site-details[sitecontact]",
        ],

        [
          "utility-application-enquirer-details[email]",
          "utility-application-site-details[email]",
        ],

        [
          "utility-application-enquirer-details[address]",
          "utility-application-site-details[siteaddress]",
        ],

        [
          "utility-application-enquirer-details[teldaytime]",
          "utility-application-site-details[telephone]",
        ],

        [
          "utility-application-enquirer-details[postcode]",
          "utility-application-site-details[postcode]",
        ],
      ];

      for (const [a, b] of elements) {
        const enquirerEl = document.querySelector<HTMLInputElement>(
          `#${CSS.escape(a)}`
        );
        const siteDetailsEl = document.querySelector<HTMLInputElement>(
          `#${CSS.escape(b)}`
        );

        if (!enquirerEl || !siteDetailsEl) return;

        siteDetailsEl.value = enquirerEl.value;
      }
    });
  }
}

const removeFileField = function (e: Event) {
  e.preventDefault();

  this.closest(".files-wrapper").remove();
};

document.querySelector("#add-file")?.addEventListener("click", function (e) {
  e.preventDefault();

  const section = document.createElement("section");
  section.classList.add("form-field", "files-wrapper");

  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.name = "files[file][]";
  fileInput.classList.add("file");
  fileInput.accept =
    "image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  const removeBtn = document.createElement("button");
  removeBtn.type = "button";
  removeBtn.innerText = "- Remove";
  removeBtn.classList.add("files-button", "files-button--remove");
  removeBtn.addEventListener("click", removeFileField);

  section.append(fileInput, removeBtn);

  document.querySelector("#files-container")!.append(section);
});

document
  .querySelector(".files-button--remove")
  ?.addEventListener("click", removeFileField);
